var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useContext, useState, useEffect } from "react";
import classNames from "classnames";
import { DataSourceType } from "@types";
import { QueryBuilderContext } from "@query-builder/QueryBuilderContext";
import { getAvailableSources, getAvailableSourcesForHistoricalData, resetConfig } from "@query-engine-service";
import { ButtonComponent, IconButton, hasValue, SearchBox, Select, useDebounce } from "uxp/components";
import { Icon } from 'uxp/components';
import { getSourceMetadataFromId, textSearch, prepareSources, SourceOriginSQL } from "@utils";
import { Loading } from "@components/Loading/Loading";
import './DataSourceBrowser.scss';
import { isSourceConfigurable, ParamEditorModal } from "@components/QueryEditor/ParamEditor";
export function renderIcon(type) {
    let iconType = null;
    switch (type) {
        case DataSourceType.SQL:
            iconType = 'database';
            break;
        case DataSourceType.DX:
            iconType = 'database';
            break;
        case DataSourceType.COLLECTION:
            iconType = 'server';
            break;
        case DataSourceType.JSON:
            iconType = 'file-alt';
            break;
        case DataSourceType.WORKFLOW:
            iconType = 'sitemap';
            break;
        case DataSourceType.Query:
            iconType = 'save';
            break;
    }
    if (!hasValue(iconType))
        return null;
    return React.createElement(Icon, { icon: ['fas', iconType] });
}
export const DataSourceBrowser = props => {
    const { source: selectedSource, onSelect, showCloseButton, onClose, history, configuredSources, query } = props;
    const context = useContext(QueryBuilderContext);
    const $L = (key) => context.uxpContext.$L(key);
    const [datasources, setDatasources] = useState([]);
    const [filteredSources, setFilteredSources] = useState([]);
    const [searchText, setSearchText] = useState('');
    const [filters, setFilters] = useState({
        type: '__all__',
        origin: '__all__'
    });
    const [sourceOrigins, setSourceOrigins] = useState({});
    const [loading, setLoading] = useState(true);
    const [filtering, setFiltering] = useState(true);
    const [editInstance, setEditinstance] = useState(null);
    const searchQuery = useDebounce(searchText, 300);
    useEffect(() => {
        getAllDataSources();
    }, [context]);
    useEffect(() => {
        setFiltering(true);
        const filtered = (datasources || []).filter(source => {
            const matchType = !hasValue(filters === null || filters === void 0 ? void 0 : filters.type) || (filters === null || filters === void 0 ? void 0 : filters.type) == '__all__' ? true : source.type == filters.type;
            const matchOrigin = !hasValue(filters === null || filters === void 0 ? void 0 : filters.origin) || (filters === null || filters === void 0 ? void 0 : filters.origin) == '__all__' ? true : source.origin == (filters === null || filters === void 0 ? void 0 : filters.origin);
            const matchQuery = hasValue(searchQuery) ? textSearch(source.name, searchQuery, true) || textSearch(source.id, searchQuery, true) : true;
            const ignoreCurrentEditingQuery = source.type == DataSourceType.Query ? source.queryId !== (context === null || context === void 0 ? void 0 : context.editingQueryId) : true;
            return matchType && matchOrigin && matchQuery && ignoreCurrentEditingQuery;
        });
        setFilteredSources(filtered);
        setFiltering(false);
    }, [datasources, searchQuery, filters]);
    function getAllDataSources() {
        return __awaiter(this, void 0, void 0, function* () {
            var _a;
            setLoading(true);
            const result = yield ((_a = (history ? getAvailableSourcesForHistoricalData : getAvailableSources)) === null || _a === void 0 ? void 0 : _a(context));
            const { sources, origins } = prepareSources((result === null || result === void 0 ? void 0 : result.definitions) || [], (props === null || props === void 0 ? void 0 : props.origins) || []);
            setDatasources(sources);
            setSourceOrigins(origins);
            setLoading(false);
        });
    }
    function renderMetadata(metadata) {
        if (!metadata)
            return null;
        return React.createElement(React.Fragment, null,
            hasValue(metadata === null || metadata === void 0 ? void 0 : metadata.model) && React.createElement("div", { className: "lqe-dsb__meta-a5d865f6" },
                React.createElement("span", { className: "lqe-dsb__meta-lbl-a5d865f6" }, $L('lqe.dsb.meta.model')),
                React.createElement("span", { className: "lqe-dsb__meta-val-a5d865f6" }, metadata.model)),
            hasValue(metadata === null || metadata === void 0 ? void 0 : metadata.collection) && React.createElement("div", { className: "lqe-dsb__meta-a5d865f6" },
                React.createElement("span", { className: "lqe-dsb__meta-lbl-a5d865f6" }, $L('lqe.dsb.meta.collection')),
                React.createElement("span", { className: "lqe-dsb__meta-val-a5d865f6" }, metadata.collection)),
            hasValue(metadata === null || metadata === void 0 ? void 0 : metadata.table) && React.createElement("div", { className: "lqe-dsb__meta-a5d865f6" },
                React.createElement("span", { className: "lqe-dsb__meta-lbl-a5d865f6" }, $L('lqe.dsb.meta.table')),
                React.createElement("span", { className: "lqe-dsb__meta-val-a5d865f6" }, metadata.table)),
            hasValue(metadata === null || metadata === void 0 ? void 0 : metadata.action) && React.createElement("div", { className: "lqe-dsb__meta-a5d865f6" },
                React.createElement("span", { className: "lqe-dsb__meta-lbl-a5d865f6" }, $L('lqe.dsb.meta.action')),
                React.createElement("span", { className: "lqe-dsb__meta-val-a5d865f6" }, metadata.action)),
            hasValue(metadata === null || metadata === void 0 ? void 0 : metadata.queryName) && React.createElement("div", { className: "lqe-dsb__meta-a5d865f6" },
                React.createElement("span", { className: "lqe-dsb__meta-lbl-a5d865f6" }, $L('lqe.dsb.meta.query')),
                React.createElement("span", { className: "lqe-dsb__meta-val-a5d865f6" }, metadata.queryName)));
    }
    function handleSelect(source) {
        const { isConfigurable } = isSourceConfigurable(source);
        if (isConfigurable) {
            const configuredSource = (configuredSources || []).find(s => s.id == source.id);
            if (!!configuredSource) {
                source.params = Object.assign(Object.assign({}, source.params), ((configuredSource === null || configuredSource === void 0 ? void 0 : configuredSource.params) || {}));
            }
            setEditinstance(source);
            return;
        }
        onSelect(source);
    }
    function renderSource(source, key) {
        const isSelected = (source === null || source === void 0 ? void 0 : source.id) == (selectedSource === null || selectedSource === void 0 ? void 0 : selectedSource.id);
        const { type, metadata } = getSourceMetadataFromId(source === null || source === void 0 ? void 0 : source.id);
        if (!type)
            return null;
        return React.createElement("div", { className: classNames("lqe-dsb__card-a5d865f6", {
                "lqe-dsb__card--selected-a5d865f6": isSelected
            }), key: key },
            React.createElement("div", { className: "lqe-dsb__card-hd-a5d865f6" },
                React.createElement("div", { className: "lqe-dsb__card-icon-a5d865f6" }, renderIcon(type)),
                React.createElement("div", { className: "lqe-dsb__card-name-a5d865f6" }, source.name)),
            React.createElement("div", { className: "lqe-dsb__card-body-a5d865f6" }, renderMetadata(metadata)),
            React.createElement("div", { className: "lqe-dsb__card-ft-a5d865f6" },
                React.createElement(ButtonComponent, { title: $L('lqe.dsb.select'), onClick: () => handleSelect(source), leftIcon: "fas check-circle", variant: "secondary", size: "smaller" })));
    }
    function renderOrigins() {
        const _origins = (Object.keys(sourceOrigins) || []).filter(o => {
            const _type = (filters === null || filters === void 0 ? void 0 : filters.type) || '__all__';
            const _types = sourceOrigins[o].types || [];
            if (_type == '__all__')
                return true;
            if (_type == DataSourceType.SQL)
                return o == SourceOriginSQL;
            return _types.includes(_type);
        });
        _origins.sort();
        return React.createElement("div", { className: "lqe-dsb__origins-a5d865f6" },
            React.createElement("div", { className: classNames("lqe-dsb__origin-a5d865f6", {
                    "lqe-dsb__origin--active-a5d865f6": filters.origin == '__all__'
                }), onClick: () => setFilters(prev => (Object.assign(Object.assign({}, prev), { origin: '__all__' }))) }, $L('lqe.dsb.all')),
            _origins.map((o, i) => React.createElement("div", { key: i, className: classNames("lqe-dsb__origin-a5d865f6", {
                    "lqe-dsb__origin--active-a5d865f6": filters.origin == o
                }), onClick: () => setFilters(prev => (Object.assign(Object.assign({}, prev), { origin: o }))) }, o)));
    }
    function refreshDatasource() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                yield resetConfig(context);
                getAllDataSources();
            }
            catch (e) { }
        });
    }
    return React.createElement("div", { className: "lqe-dsb-a5d865f6" },
        React.createElement("div", { className: "lqe-dsb__head-a5d865f6" },
            React.createElement("div", { className: "lqe-dsb__hd-title-a5d865f6" }, $L('lqe.dsb.title')),
            React.createElement("div", { className: "lqe-dsb__hd-actions-a5d865f6" },
                React.createElement(SearchBox, { value: searchText, onChange: setSearchText }),
                React.createElement(ButtonComponent, { title: $L('lqe.dsb.refresh'), onClick: refreshDatasource, leftIcon: "fas sync-alt", variant: "secondary", size: "small" }),
                showCloseButton && React.createElement(IconButton, { type: "close", onClick: () => onClose === null || onClose === void 0 ? void 0 : onClose() }))),
        React.createElement("div", { className: "lqe-dsb__body-a5d865f6" },
            React.createElement("div", { className: "lqe-dsb__sidebar-a5d865f6" },
                React.createElement("div", { className: "lqe-dsb__filter-hd-a5d865f6" }, $L('lqe.dsb.filter-hd')),
                React.createElement("div", { className: "lqe-dsb__filter-group-a5d865f6" },
                    React.createElement("div", { className: "lqe-dsb__filter-lbl-a5d865f6" }, $L('lqe.dsb.category')),
                    React.createElement(Select, { selected: filters.type || '__all__', onChange: v => setFilters(prev => (Object.assign(Object.assign({}, prev), { type: v }))), options: [{
                                label: $L('lqe.dsb.all'),
                                value: '__all__'
                            }, ...Object.entries(DataSourceType).filter(t => { var _a, _b; return ((_a = props === null || props === void 0 ? void 0 : props.origins) === null || _a === void 0 ? void 0 : _a.length) > 0 ? (_b = props === null || props === void 0 ? void 0 : props.origins) === null || _b === void 0 ? void 0 : _b.includes(t[1]) : true; }).map(t => ({
                                label: t[0],
                                value: t[1]
                            }))], className: "lucy-query-engine-source-filter-input-a5d865f6", dropdownClassname: "lucy-query-engine-source-filter-input-dropdown" })),
                React.createElement("div", { className: "lqe-dsb__filter-group-a5d865f6" },
                    React.createElement("div", { className: "lqe-dsb__filter-lbl-a5d865f6" }, $L('lqe.dsb.location')),
                    loading ? React.createElement(Loading, null) : renderOrigins())),
            React.createElement("div", { className: "lqe-dsb__cards-a5d865f6" }, loading || filtering ? React.createElement(Loading, null) : filteredSources.map((source, key) => renderSource(source, key)))),
        React.createElement(ParamEditorModal, { show: !!editInstance, onClose: () => setEditinstance(null), source: editInstance, onSave: updatedSource => {
                onSelect(updatedSource);
                setEditinstance(null);
            }, query: query }));
};
